$(document).ready(function() {
  function removeOptions(array) {
    for (var i = 0; i < array.length; i++) {
        $('#phone_line option[value="' + array[i] + '"]').remove();
    }
  }
  $(document).on('change', "#user_location_id", function (e)
  {
    var locationID = $(this).val()
    console.log(locationID)
    $.ajax({
    type: 'GET',
    dataType: 'json',
    url: `/api/v1/locations/${locationID}`,
     
    success: function(response) {
      console.log("ppppp")
      
      const storeSelect = $("#user_store_id");
      const wrapper = $("#role_store").find('.select-wrapper ul');
      if (response.data.store_info) {
        

        // 1. Show the container
        $("#role_store").removeClass('display-none');

      
        storeSelect.empty(); 
        wrapper.empty();   

      
        storeSelect.append(`<option value="" disabled selected>Select store</option>`);
        wrapper.append(`<li class="disabled selected"><span>Select store</span></li>`);

        
        response.data.store_info.forEach(item => {
          const id = item.id.toString();
          const name = item.name;

          
          storeSelect.append(`<option value="${id}">${name}</option>`);

        
          wrapper.append(`<li class=""><span>${name}</span></li>`);
        });

     
        M.FormSelect.init(storeSelect);
      }
      else
      {
        storeSelect.empty(); 
        wrapper.empty();   
        $("#role_store").addClass('display-none');
      }

    }
    });
  })
})